var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"contentprovider"},[_c('ContentProvidersForm',{attrs:{"contentProvider":_vm.contentProvider,"editContentProvider":_vm.editContentProvider},on:{"itemUpdate":_vm.onItemUpdate}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }